import { LeadParagraph } from "../../../../src/components/LeadParagraph";
import { Donut } from "../../../../src/components/Donut";
import * as React from 'react';
export default {
  LeadParagraph,
  Donut,
  React
};